import * as actions from 'actions';
import cx from 'classnames';
import { delay } from 'helpers';
import { random, round } from 'lodash';
import T from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import reactHtmlParser from 'react-html-parser';
import { push } from 'redux-first-router';
import Link from 'redux-first-router-link';
import styles from './caseTile.css';

class CaseTile extends React.Component {
  state = {
    loaded: false,
  };

  componentDidMount() {
    if (this.imgNode) {
      this.handleImageLoaded();
    }
  }
  randomNumber = round(random(0.4, 0.9), 2);

  clickHandler = (e) => {
    e.preventDefault();
    delay(0)
      .then(() => this.props.openOverlay(this.props.color))
      .then(() => delay(800))
      .then(() => push(this.props.href))
      .catch(console.log);
  };

  handleImageLoaded = () => {
    if (this.state.loaded === false) {
      this.setState({ loaded: true });
      this.props.loadCb();
    }
  };
  render() {
    const {
      img, alt, client, description, color, href, back,
    } = this.props;
    const { loaded } = this.state;
    return (
      <Link
        style={{
          transitionDelay: `${this.randomNumber}s`,
          animationDelay: ` ${this.randomNumber}s`,
        }}
        className={cx(
          styles.root,
          loaded && styles.loaded,
          back && styles.scale,
        )}
        to={href}
        onClick={this.clickHandler}
      >
        <img
          className={styles.img}
          src={img}
          alt={alt}
          width="400"
          height="400"
          ref={(img) => {
            this.imgNode = img;
          }}
          onLoad={this.handleImageLoaded}
        />

        <div style={{ backgroundColor: color }} className={styles.details}>
          <h2 className={styles.client}>
            {reactHtmlParser(client.toUpperCase())}
          </h2>
          <h2 className={styles.description}>
            {reactHtmlParser(description.toUpperCase())}
          </h2>
        </div>
      </Link>
    );
  }
}

CaseTile.defaultProps = {
  img: '',
  alt: '',
  client: '',
  description: '',
  color: '',
  href: '',
};

CaseTile.propTypes = {
  img: T.string.isRequired,
  alt: T.string.isRequired,
  client: T.string.isRequired,
  description: T.string.isRequired,
  color: T.string.isRequired,
  href: T.string.isRequired,
  loadCb: T.func.isRequired,
  back: T.bool.isRequired,
  openOverlay: T.func.isRequired,
  closeOverlay: T.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  openOverlay: color => dispatch(actions.openOverlay(color)),
});

export default connect(null, mapDispatchToProps)(CaseTile);



// WEBPACK FOOTER //
// ./src/components/modules/CaseTile/CaseTile.js